import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default (
  <Route key="/consumer/features/ai-photo-enhancer" element={<DefaultConsumerLayout />}>
    <Route path="consumer/features/ai-photo-enhancer" element={<AsyncPage />} />
  </Route>
);
